import { Configuration } from '@linktivity/hirakuza';
import { message } from '@linktivity/link-ui';
import { ErrorCode } from '@/services/const';
import { auth } from '@/stores';

const BASE_PATH = import.meta.env.VITE_APP_BASE_PATH as string;

const refreshToken = async (
  init: RequestInit,
  url: string,
  fetch: (input: RequestInfo, init?: RequestInit) => Promise<Response>
) => {
  const accessToken = await auth.refreshExpiredToken();
  if (accessToken) {
    init.headers = {
      ...init.headers,
      Authorization: accessToken
    };
    return fetch(url, init);
  }
};

const config = new Configuration({
  basePath: BASE_PATH,
  middleware: [
    {
      pre: async context => {
        const requestHeaders: HeadersInit = new Headers({
          'Content-Type': 'application/json'
        });
        requestHeaders.append('Authorization', auth.getAccessToken());
        context.init.headers = requestHeaders;
      },
      post: async context => {
        if (!context.response.ok) {
          // handle error
          const data = await context.response.json();
          if (context.response.status === 401) {
            // TODO replace error code
            if (data?.error_code === ErrorCode.TokenExpired) {
              return refreshToken(context.init, context.url, context.fetch);
            } else {
              localStorage.clear();
              location.href = '/login';
            }
          } else {
            message.error(data?.error_message || data?.error_code, 10);
            return data;
          }
        }
      }
    }
  ]
});

export default config;
